module.exports = __webpack_public_path__ + "static/media/tcmax-logo-header.a1e8bf44.jpg";